module.exports = __webpack_public_path__ + "static/media/book.cdedc9f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/book.png
// module id = 584
// module chunks = 0